import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseNavigationService } from '@shared/utils/navigation';
import { BaseHelperComponent } from '../base-helper/base-helper.component';

@Component({
    selector: 'feature-page-layout-page-not-found',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.css'],
    standalone: false
})
export class PageNotFoundComponent extends BaseHelperComponent implements OnInit {
  constructor(public router: Router, _navigationService: BaseNavigationService) {
    super(_navigationService);
  }

  ngOnInit(): void {}
}
